import type { IPointerHandler } from '@/components/viewPort/PointerController';
import * as THREE from 'three';

import type { ICameraController, IRaycaster } from '../../interfaces';
import type { SyntheticEvent } from '@/components/viewPort/SyntheticEvent';
import type { ViewsService } from '../../Views.service';

export class PointerHandlerGhostCursor implements IPointerHandler {
  private readonly _cameraController: ICameraController;

  private readonly _rayCaster: IRaycaster;

  private readonly _viewsService: ViewsService;

  public setParent(/*parent: IPointerController*/): void {
    return;
  }

  public constructor(cameraController: ICameraController, rayCaster: IRaycaster, viewsService: ViewsService) {
    this._cameraController = cameraController;
    this._rayCaster = rayCaster;
    this._viewsService = viewsService;
  }

  private _onPointerMove(event: MouseEvent): void {
    const currentView = this._viewsService.currentView;
    if (currentView) {
      const { offsetX, offsetY } = event;
      const point = this._rayCaster.rayCast(new THREE.Vector2(offsetX, offsetY))?.point;
      if (!point) {
        currentView.setGhostCursor(undefined);
      } else {
        const cameraDirection = this._cameraController.getCameraDirection();
        currentView.setGhostCursor({
          coordinates: point,
          direction: cameraDirection
        });
      }
    } else {
      console.warn('Ghost cursor: Current View is undefined');
    }
  }

  public onPointerMove(event: SyntheticEvent<PointerEvent>): void {
    this._onPointerMove(event.originalEvent);
  }

  public onWheel(event: SyntheticEvent<WheelEvent>): void {
    this._onPointerMove(event.originalEvent);
  }

  public onPointerLeave(): void {
    this._viewsService.currentView?.setGhostCursor(undefined);
  }
}
